export class ContactTypes {
  id: number;
  typeValue: string;
}
